/* eslint-disable react-hooks/rules-of-hooks */
import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import { useRequest } from 'ahooks';
import _ from 'lodash-es';

interface ICommonOptions {
  onFinally?: () => void;
}

// company detail financials  IPO
export const useFinancialsIPO = (
  params?: {
    company_id: string;
    isShowRef1?: boolean;
  },
  options?: ICommonOptions,
) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/ipo',
      method: 'post',
      data: _.omit(params, 'isShowRef1'),
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'financials',
    manual: false,
    onFinally,
  });
  return {
    ...data,
  };
};
// company detail financials  Investments
export const useInvestments = <T>(params?: T, options?: ICommonOptions) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/investments',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'investments',
    manual: false,
    onFinally,
  });
  return {
    ...data,
  };
};

// company detail financials  Investors
export const useInvestors = (...[params, options]: Parameters<typeof useInvestments>) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params?.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/investors',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'investors',
    manual: false,
    onFinally,
  });
  return {
    ...data,
  };
};

// company detail financials   Funding Rounds
export const useFundingRounds = <T>(params: T, options?: ICommonOptions) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params?.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/fundingrounds',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'fundingRounds',
    manual: false,
    onFinally,
  });
  return {
    ...data,
  };
};

// company detail financials   Acquisitions
export const useAcquisitions = (...[params, options]: Parameters<typeof useFundingRounds>) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params?.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/acquisitions',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'acquisitions',
    manual: false,
    onFinally,
  });
  return {
    ...data,
    onFinally,
  };
};

// company detail financials   Exits
export const useExits = <T>(params: T, options?: ICommonOptions) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params?.company_id)) return {}; // 添加ID校验规则

  const { onFinally } = options || {};
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/financials/exits',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'exits',
    manual: false,
    onFinally,
  });
  return {
    ...data,
  };
};
